module.exports = __webpack_public_path__ + "img/tutorias_2.7f2bd802.svg";